<!--
 * @Description:
 * @Author: Lizhiliang
 * @Date: 2022-12-16 14:47:01
 * @LastEditTime: 2024-01-05 16:31:11
 * @LastEditors: lizhiliang
 * @Usage:
-->
<template>
  <div id="app">
    <router-view v-if="isShow" />
  </div>
</template>
<script>


export default {
  provide() {
    return {
      reload: this.reload,
      show: this.showView()
    };
  },
  created() {
    const obj = this.$geEncryption();
    console.log('加密秘钥', obj);
  },
  data() {
    return {
      isShow: true
    };
  },

  updated() {
    this.$nextTick(() => {
      // document.querySelector('.ux-pagination.is-background')?.classList.remove('is-background');
    });
  },

  methods: {
    reload() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    },

    showView() {
      this.isShow = true;
    }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  position: relative;
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
</style>
